import axios, { AxiosPromise } from 'axios';
import { IAddressSuggestion } from '../models/Account/IAddressSuggestion';

const instance = axios.create({
  baseURL: '/',
  timeout: 120000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: false,
});

function smartStreetService() {
  function lookup(searchParam: String): AxiosPromise<IAddressSuggestion[]> {
    return instance.get('/api/addresslookup', {
      params: {
        search: searchParam,
      },
    });
  }
  return { lookup };
}

export default smartStreetService;
